export const initialColumnVisibility = {
  email: false,
  project_type: false,
  store_ref_number: false,
  is_employed: false,
  is_student: false,
  citizenship: false,
  student_id_valid_until: false,
  bank_account_number: false,
};
